import { request } from "./request";

const BASE_URL = "/api/file_upload";

export default {
  async uploadFile(dataKey, file) {
    const formData = new FormData();
    formData.append("file", file);
    return await request({
      url: `${BASE_URL}/${dataKey}`,
      method: "POST",
      data: formData,
    });
  },

  async deleteFile(fileId, dataKey) {
    return await request({
      url: `${BASE_URL}/${fileId}`,
      method: "DELETE",
      data: { data_key: dataKey },
    });
  },

  async getFileData(dataKey) {
    return await request({
      url: `${BASE_URL}/${dataKey}`,
      method: "GET",
    });
  },
};
